import * as React from "react"
import Button from "@mui/material/Button"
import { formatCustomerName, formatPhoneNumber } from "../../Utils"
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import EmailIcon from '@mui/icons-material/Email';
import { Box } from "@mui/material";
import PhoneModal from "../modals/PhoneModal"
import EmailModal from "../modals/EmailModal"
import { AXIOS_API_INSTANCE } from "../../Constants";
import { send_authorized_request } from "../../Constants/cognito";
import { useSnackbar } from "notistack";



export default function ServiceOrderPreferredContact({ serviceOrder, setServiceOrder, setServiceOrderSavingStep, editable = false }) {
    const { enqueueSnackbar } = useSnackbar();
    const [phoneModal, setPhoneModal] = React.useState({
        open: false,
        callback: null,
        acceptEmpty: true,
    })
    const [emailModal, setEmailModal] = React.useState({
        open: false,
        callback: null,
        acceptEmpty: true,
    })
    const email_options = (serviceOrder.customer.email ? [{ value: serviceOrder.customer.email, name: formatCustomerName(serviceOrder.customer) }] : []
    ).concat(
        (serviceOrder.customer.customer_contacts ?? []).sort((a, b) => (a.first_name + ' ' + a.last_name).localeCompare(b.first_name + ' ' + b.last_name)).map((contact) => contact.email ? { value: contact.email, name: `${contact.first_name} ${contact.last_name}` } : undefined).filter((x) => x !== undefined)
    )
    const phone_options = (serviceOrder.customer.phone ? [{ value: serviceOrder.customer.phone, name: formatCustomerName(serviceOrder.customer) }] : []
    ).concat(
        (serviceOrder.customer.customer_contacts ?? []).sort((a, b) => (a.first_name + ' ' + a.last_name).localeCompare(b.first_name + ' ' + b.last_name)).map((contact) => contact.phone ? { value: contact.phone, name: `${contact.first_name} ${contact.last_name}` } : undefined).filter((x) => x !== undefined)
    )

    const editPhone = () => {
        setPhoneModal({
            ...phoneModal,
            open: true,
            title: `Edit Preferred Phone Number`,
            providedPhone: serviceOrder.preferred_phone ?? '',
            closeModal: (phone) => {
                if (phone !== false) {
                    setServiceOrderSavingStep(1)
                    send_authorized_request(() => AXIOS_API_INSTANCE.post(`serviceorders/${serviceOrder.id}/update_preferred_phone`, { preferred_phone: phone }).then((serviceOrder) => {
                        setServiceOrderSavingStep(0)
                        enqueueSnackbar(`Successfully updated preferred phone to ${phone}`, { variant: 'success' })
                        setServiceOrder(serviceOrder.data.data)
                    }).catch((error) => {
                        setServiceOrderSavingStep(0)
                        enqueueSnackbar(`Failed to update preferred phone <${error.response?.data?.message ?? "Unknown Error Occurred"}>`, { variant: 'error' })
                    }))
                }
                setPhoneModal({ ...phoneModal, open: false })
            }
        })
    }

    const editEmail = () => {
        setEmailModal({
            ...emailModal,
            open: true,
            title: `Edit Preferred Email`,
            providedEmail: serviceOrder.preferred_email ?? '',
            closeModal: (email) => {
                if (email !== false) {
                    setServiceOrderSavingStep(1)
                    send_authorized_request(() => AXIOS_API_INSTANCE.post(`serviceorders/${serviceOrder.id}/update_preferred_email`, { preferred_email: email }).then((serviceOrder) => {
                        setServiceOrderSavingStep(0)
                        enqueueSnackbar(`Successfully updated preferred email to ${email}`, { variant: 'success' })
                        setServiceOrder(serviceOrder.data.data)
                    }).catch((error) => {
                        setServiceOrderSavingStep(0)
                        enqueueSnackbar(`Failed to update preferred email <${error.response?.data?.message ?? "Unknown Error Occurred"}>`, { variant: 'error' })
                    }))
                }
                setEmailModal({ ...emailModal, open: false })
            }
        })
    }

    return <React.Fragment>
        <Box>
            <Button onClick={editPhone}><PhoneAndroidIcon sx={{ mr: 1 }} />{serviceOrder.preferred_phone ? formatPhoneNumber(serviceOrder.preferred_phone) : 'N/A'}</Button>
        </Box>
        <Box>
            <Button onClick={editEmail}><EmailIcon sx={{ mr: 1 }} /> {serviceOrder.preferred_email ? serviceOrder.preferred_email : 'N/A'}</Button>
        </Box>
        <PhoneModal
            {...phoneModal}
            options_list={phone_options}
        />
        <EmailModal
            {...emailModal}
            options_list={email_options}
        />
    </React.Fragment>
}